import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-polyglot'
import { stopAsyncValidation, getFormValues } from 'redux-form'
import TrackingContainer from '../../tracking/trackingContainer'
import {
  fetchEntityFilterSubTypeCombo, fetchEntitySubTypeCombo, fetchIaeCombo, fetchOrganizedUnitsTreeComboByPermission, fetchOrganizedUnitsCombo, fetchLowestOrganizedUnits
  , fetchEntityCountryTypeCombo, fetchEntityStateTypeCombo, fetchEntityCityTypeCombo, fetchEntityTownTypeCombo, fetchEntityColonyTypeCombo
  , fetchEntityCPTypeCombo, fetchCommercialSocietyTypeCombo, fetchOrganizedUnitsAcceptClientsCombo, fetchEntityTypes, fetchActivityBpro, fetchOrganizedUnitsTree,
  fetchClientDataAddress, fetchEntityMaritalStatusCombo, fetchDossierSubTypes, fetchFinancingCompaniesBy, fetchCancelCombo, fetchDossierTypes
} from '../../../actions/combos/combos'
import {
  getClientFleetPermissions, getFleetModel, fetchFleetsManagement, resetFleetManagementFilters, modifyFleetManagementFilters, exportFleetsManagement, openCreateEditFleetModal, closeCreateEditFleetModal, openEditFleetModal,
  openOperateFleetModal, closeOperateFleetModal, openDocumentFleetModal, openConditionsFleetComponent, openEconomicFleetModal, showFrontEconomicPlan, getDossierDetailsFleet, showAuditFleetModal, createUpdateFleet, initializeOperationActionsCombo,
  fetchGetCanCreateOperateServices, getDeliveriesDetailsFleet, getDeliveriesDetailsFleetSuccess, getDossierHistoricalsFleet, setActiveFleetTab
} from '../../../actions/management/management'
import {
  openDataSalesFleetModal, openDataPurchasesFleetModal, openDataContactFleetModal, openDataPaperWorkFleetModal, openDataFinancingFleetModal, openDataDeliveryFleetModal, openDataOtherDataFleetModal
} from '../../../actions/management/auxModals/auxModals'
import { openDocumentEditionModalFleet, openDocumentEditionModal } from '../../../actions/dossier/common/documentEditionModal'
import {
  setOperateActionSendToApprovalProcess, setOperateActionApproveProcess, setOperateActionApprovePaperworkProcess, setOperateActionSendToAgencyProcess, setOperateActionStoreProcess,
  setOperateActionPrintDeliveryNoteProcess, setApproveActionProcess, setDeleteFleetProcess, setOperateActionRejectProcess, setOperateActionDeleteProcess, setOperateDataServiceFleetProcess,
  setOperateActionSendToApprovalPurchaseProcess, setOperateActionApprovePurchaseProcess, setOperateActionRejectPurchaseProcess, setOperateActionDeletePurchaseProcess, setOperateActionStorePurchaseProcess
} from '../../../actions/unattendedProcess/unattendedProcess'
import { openModal, yesNoModal } from '../../../actions/common'
import { fetchDefaultEntity } from '../../../actions/dossier/common/client'
import { fetchNotValidDatesService } from '../../../actions/dossier/sales'
import Fleets from '../../../components/management/fleets/Fleets'

export function mapStateToProps (state) {
  return {
    combos: state.combos,
    addNewFleet: state.management.addNewFleetModal,
    fleetData: state.management.createNewFleetModal,
    dossier: state.management.createNewFleetModal.dossier,
    dossierFleetDetails: state.management.dossierFleetDetails,
    purchaseFleetDetails: state.management.purchaseFleetDetails,
    sectionsGeneral: state.auth.sections,
    operationActions: state.management.operateFleetModal.operationActions,
    dataActions: state.management.operateFleetModal.dataActions,
    dataPaperWorkActions: state.management.operateFleetModal.dataPaperWorkActions,
    operationPaperWorkActions: state.management.operateFleetModal.operationPaperWorkActions,
    dataPurchaseActions: state.management.operateFleetModal.dataPurchaseActions,
    operationPurchaseActions: state.management.operateFleetModal.operationPurchaseActions,
    componentsModalConfiguration: state.management.operateFleetModal.componentsModalConfiguration,
    dossierServiceRelateds: state.salesDossier.dossierServiceRelateds,
    deliveryFleetDetails: state.management.deliveryFleetComponent.deliveryFleetDetails,
    dossierHistoricalFleetDetails: state.management.dossierHistoricalFleetDetails,
    formValues: getFormValues('fleets')(state)
  }
}
export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      getClientFleetPermissions,
      getFleetModel,
      setDeleteFleetProcess,
      openModal,
      yesNoModal,
      fetchFleetsManagement,
      resetFleetManagementFilters,
      modifyFleetManagementFilters,
      exportFleetsManagement,
      openCreateEditFleetModal,
      closeCreateEditFleetModal,
      openEditFleetModal,
      openOperateFleetModal,
      openDocumentFleetModal,
      openConditionsFleetComponent,
      openEconomicFleetModal,
      showFrontEconomicPlan,
      getDossierDetailsFleet,
      showAuditFleetModal,
      fetchEntityFilterSubTypeCombo,
      fetchEntitySubTypeCombo,
      fetchIaeCombo,
      fetchOrganizedUnitsTreeComboByPermission,
      fetchOrganizedUnitsCombo,
      fetchLowestOrganizedUnits,
      fetchEntityCountryTypeCombo,
      fetchEntityStateTypeCombo,
      fetchEntityCityTypeCombo,
      fetchEntityTownTypeCombo,
      fetchEntityColonyTypeCombo,
      fetchEntityCPTypeCombo,
      fetchCommercialSocietyTypeCombo,
      fetchOrganizedUnitsAcceptClientsCombo,
      fetchEntityTypes,
      fetchActivityBpro,
      fetchOrganizedUnitsTree,
      fetchClientDataAddress,
      fetchEntityMaritalStatusCombo,
      fetchDossierSubTypes,
      createUpdateFleet,
      stopAsyncValidation,
      initializeOperationActionsCombo,
      openDocumentEditionModalFleet,
      openDocumentEditionModal,
      openDataSalesFleetModal,
      openDataPurchasesFleetModal,
      openDataContactFleetModal,
      openDataDeliveryFleetModal,
      openDataPaperWorkFleetModal,
      openDataFinancingFleetModal,
      setOperateActionSendToApprovalProcess,
      setOperateActionApproveProcess,
      setOperateActionApprovePaperworkProcess,
      setOperateActionSendToAgencyProcess,
      setOperateActionPrintDeliveryNoteProcess,
      setOperateActionStoreProcess,
      setApproveActionProcess,
      openDataOtherDataFleetModal,
      fetchGetCanCreateOperateServices,
      fetchFinancingCompaniesBy,
      setOperateActionRejectProcess,
      setOperateActionDeleteProcess,
      fetchCancelCombo,
      fetchDefaultEntity,
      fetchNotValidDatesService,
      setOperateDataServiceFleetProcess,
      closeOperateFleetModal,
      fetchDossierTypes,
      getDeliveriesDetailsFleet,
      getDeliveriesDetailsFleetSuccess,
      getDossierHistoricalsFleet,
      setActiveFleetTab,
      setOperateActionSendToApprovalPurchaseProcess,
      setOperateActionApprovePurchaseProcess,
      setOperateActionRejectPurchaseProcess,
      setOperateActionDeletePurchaseProcess,
      setOperateActionStorePurchaseProcess
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(TrackingContainer(Fleets, true)))
